export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-maneuver-instructions-960-03682a72ba544889a1f24cbe108a976b.png";